module.exports = __webpack_public_path__ + "img/1.e30b2f40.png";